<template>
  <div class="c-panel u-mrgn-v--4">
    <div class="c-panel__body">
      <div class="o-layout o-layout--responsive">
        <div class="o-layout__item u-10of12 u-clearfix">
          <div class="u-float-left">
            <a :href="miUrl" data-no-turbolink="true">
              <img :src="product.logo_url" style="width:70px;height:70px;" />
            </a>
          </div>
          <div class="u-float-left u-pad-left--3">
            <div class="u-txt--small">
              <a :href="typeUrl" data-no-turbolink="true" class="u-fg--ash-dark qa-product-header__type"
                >Reksa Dana {{ product.type }}
              </a>
            </div>
            <h1 class="u-txt--medium u-mrgn-bottom--1">
              <a
                :href="productUrl"
                data-no-turbolink="true"
                class="u-txt--medium u-txt--bold u-fg--black qa-product-header__name"
                >{{ product.name }}
              </a>
            </h1>
            <div class="u-mrgn-bottom--1">
              <a :href="miUrl" data-no-turbolink="true" class="u-txt--fair u-fg--red-brand qa-product-header__im-name"
                >{{ product.im_name }}
              </a>
            </div>
          </div>
        </div>
        <div class="o-layout__item u-2of12 u-align-right">
          <div class="u-txt--small u-fg--ash-dark qa-product-header__nav-date">NAB/Unit ({{ navDate }})</div>
          <div class="u-txt--medium u-txt--bold qa-product-header__nav-value">
            {{ navValue }}
          </div>
          <RodValue class="u-txt--base qa-product-header__return" :return-value="product.return_one_day" is-desktop />
          <RodTooltip class="u-mrgn-left--0 custom-rod-tooltip" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RodValue from 'shared/components/RodValue';
import RodTooltip from 'shared/components/RodTooltip';
import { money } from 'shared/helpers/numberHelper';
import dayjs from 'dayjs';
import { generateSeoTypeUrl, generateSeoProductUrl, generateSeoInvestmentManagerUrl } from 'shared/helpers/seoMap';

export default {
  name: 'ProductHeader',
  components: {
    RodValue,
    RodTooltip,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    typeUrl() {
      return generateSeoTypeUrl(this.product.type);
    },
    miUrl() {
      return generateSeoInvestmentManagerUrl(this.product.im_code);
    },
    productUrl() {
      return generateSeoProductUrl(this.product.isin_code);
    },
    navValue() {
      if (this.product.last_nav_value) {
        return money(this.product.last_nav_value);
      }
      return '';
    },
    navDate() {
      if (this.product.last_nav_updated_at) {
        return dayjs(this.product.last_nav_updated_at).format('DD MMMM YYYY');
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-rod-tooltip /deep/ .c-popover__outer {
  left: -75px;

  .c-popover__inner::before {
    left: 91%;
  }
  .c-popover__inner::after {
    left: 91%;
  }
}
</style>
